(function () {
  var init = function () {
    var page = document.querySelector('[data-page="therapie-neuropatia-ciatica-chile"]');
    if (!page) return;

    page.querySelectorAll('.tp-cta, .tp-sticky-cta').forEach(function (cta) {
      cta.setAttribute('aria-label', cta.textContent.trim());
    });

    var stickyCta = page.querySelector('.tp-sticky-cta-wrap');
    if (stickyCta) {
      var stickyCtaLink = stickyCta.querySelector('.tp-sticky-cta');
      var updateStickyCta = function () {
        if (window.innerWidth > 900) {
          stickyCta.classList.remove('is-visible');
          stickyCta.setAttribute('aria-hidden', 'true');
          if (stickyCtaLink) {
            stickyCtaLink.tabIndex = -1;
          }
          return;
        }
        var scrollable = document.documentElement.scrollHeight - window.innerHeight;
        var progress = scrollable > 0 ? window.scrollY / scrollable : 0;
        var shouldShow = progress >= 0;
        stickyCta.classList.toggle('is-visible', shouldShow);
        stickyCta.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        if (stickyCtaLink) {
          stickyCtaLink.tabIndex = shouldShow ? 0 : -1;
        }
      };

      updateStickyCta();
      window.addEventListener('scroll', updateStickyCta, { passive: true });
      window.addEventListener('resize', updateStickyCta);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
